import styled from 'styled-components';

export const ArrowButtonsWrapper = styled.div`
  button {
    background: rgba(255, 255, 255, 0.2) !important;

    &:hover,
    &:active,
    &:focus:not(:focus-visible) {
      background: #00b0f0 !important;
    }
  }
`;
